module.exports = __webpack_public_path__ + "static/media/img6.90106c4d.jpg";